import { Api } from '../api'
import { Cron } from '../cron'
import { Database, databaseFactory } from '../database'
import { Metric } from '../types'
import { ConstructorArgs, SetMetricsConfigArgs } from './metrics.types'

const DATABASE_NAME_SPACE = 'SDK_PAYMENTS_METRIC_LOGS'
const INIT_ITEMS = 0

export class Metrics {
  protected database: Database
  protected cron: Cron | undefined = undefined
  protected api: Api
  protected enableMetrics: boolean
  protected debug: boolean = false
  protected enableCron: boolean
  protected batchTime?: number | undefined
  #totalItems = INIT_ITEMS

  constructor({
    organizationName,
    api,
    enableMetrics,
    debug = false,
    enableCron = false,
    batchTime,
  }:ConstructorArgs) {
    this.api = api
    this.database = databaseFactory(organizationName, DATABASE_NAME_SPACE)
    this.enableMetrics = enableMetrics
    this.debug = debug
    this.enableCron = enableCron
    this.batchTime = batchTime
  }

  public startCron() {
    if (this.cron) {
      this.cron.stop()
    }

    if (this.enableCron && this.batchTime && this.enableMetrics) {
      if(this.debug) {
        console.log('Metrics --> startingCron()',{ enableCron: this.enableCron, batchTime: this.batchTime })
      }
      this.cron = new Cron(this.batchTime, this.api.sendMetricsBatch.bind(this.api), this.database)
      this.cron.sendBatch()
    }
  }

  public async setMetric(metricArgs: Metric, maxBatchQueued: number) {
    if (!this.enableMetrics) {
      return Promise.resolve()
    }

    if(this.debug) {
      console.log('Metrics --> setMetric()',{ metricArgs })
    }

    await this.database.setItem(metricArgs)
    this.#totalItems += 1

    if (this.#totalItems >= maxBatchQueued) {
      this.#totalItems = INIT_ITEMS
      await this.sendBatch()
    }
  }

  public setConfig({
    enableMetrics,
  }:SetMetricsConfigArgs) {
    if(this.debug) {
      console.log('Metrics --> setConfig()',{ enableMetrics })
    }

    if(typeof enableMetrics === 'boolean') {
      this.enableMetrics = enableMetrics
      this.startCron()
    }
  }

  public async sendBatch() {
    if(!this.enableMetrics) {
      return Promise.resolve()
    }

    if(this.debug) {
      console.log('Metrics --> sendBatch()')
    }
    const items = await this.database.getAllItems()

    if (items.length) {
      return this.api.sendMetricsBatch(items)
    }
  }
}
